import handleTickPositioner from "./ticks/handle-tick-positioner"
import { getPatterns } from "./handle-patterns"
import { handleSeriesData } from "./handle-series-data"

export default function(props, colorTheme, accessibilityGraphStyles = []) {
    let colors = props.colors?.length > 0 ? props.colors : colorTheme
    let seriesData = []
    let categories = []
    let tickPositioner = null

    switch(props.graphType) {
        case "pie":
            seriesData = props.graphData
            colors = props.useAccessibilityStyles ? getPatterns(colors) : colors
            break
        default: 
            tickPositioner = handleTickPositioner(props.graphData[0].data.map(({ label }) => label.toString()))
            categories = handleCategoriesData(props.graphData)
            seriesData = handleSeriesData(props, accessibilityGraphStyles)
            break
    }

    return {
        ...props,
        colors: colors,
        categories: categories,
        seriesData: seriesData,
        tickPositioner: tickPositioner
    }
}

function handleCategoriesData(graphData) {
    return graphData[0].data.map(({ label }) => {
        return label.toString()
    })
}
